import { Box, IconButton, Stack } from '@mui/material';
import { common } from '@mui/material/colors';
import BaseNumberField from 'common/components/base-number-field';
import BaseRating from 'common/components/base-rating';
import BaseTextField from 'common/components/base-text-field';
import RequiredLabel from 'common/components/required-label';
import { colors, styleInputNumber } from 'common/constants';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { createStyleSheet } from 'utils/helpers';
import StarIcon from '@mui/icons-material/Star';
import { IQuestionAnswer, IQuestionBaseProps } from 'types/campaign-design';
import QuestionDnD from './question-dnd';
import MinusIcon from '@mui/icons-material/Remove';
import PlusIcon from '@mui/icons-material/Add';
import { useAppSelector } from 'common/hook';

interface QuestionScoreStarProps extends IQuestionBaseProps {
    starScoreFull: boolean;
}

// xử lý cả 2 loại question score star full và half
const QuestionScoreStar: React.FC<QuestionScoreStarProps> = ({
    starScoreFull,
    question,
    ...props
}) => {
    const { watch, control, setValue } = useFormContext();
    const {
        // fields,
        // append,
        remove,
        insert,
    } = useFieldArray({
        control,
        name: `data.answers`,
    });
    const numberOfRows = watch(`data.numberOfRows`);
    const quantity = watch('data.quantity');
    const answers = watch('data.answers');

    const removeAnswer = (fieldIndex: number) => {
        remove(fieldIndex);
        setValue('data.numberOfRows', numberOfRows ? numberOfRows - 1 : 0);
    };

    const insertAnswer = (fieldIndex: number) => {
        console.log(numberOfRows + 1);
        insert(fieldIndex + 1, {
            id: null,
            answer: `Tuỳ chọn ${numberOfRows + 1}`,
        });
        setValue('data.numberOfRows', numberOfRows + 1);
    };

    // Tuỳ chọn số lượng sao
    // React.useEffect(() => {
    //     fields.forEach((field, fieldIndex) => {
    //         setValue(
    //             `data.answers.${fieldIndex}.score`,
    //             !starScoreFull ? quantity - 0.5 : quantity
    //         );
    //     });
    // }, [quantity, starScoreFull, fields, setValue]);

    const currentCampaign = useAppSelector(
        (state) => state.campaignState.campaign
    );

    const isCampaignPublicWithCode =
        currentCampaign?.kind === 'public_with_code';

    return (
        <Box>
            <Stack p={'0px 35px 35px 35px'} gap={1}>
                <Box sx={{ display: 'flex', alignItems: 'start', gap: 8 }}>
                    <QuestionDnD {...props} question={question} />
                    {!question.answerFromOtherQuestionLogic?.id &&
                        answers?.length === 0 && (
                            <Box
                                display={'flex'}
                                alignItems={'center'}
                                width={'100%'}
                            >
                                <IconButton onClick={() => insertAnswer(0)}>
                                    <PlusIcon />
                                </IconButton>
                                <Box component={'span'}>Thêm đáp án</Box>
                            </Box>
                        )}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                            width: '100%',
                        }}
                    >
                        {answers?.map(
                            (item: IQuestionAnswer, fieldIndex: number) => {
                                const answerValue = watch(
                                    `data.answers.${fieldIndex}.answer`
                                );
                                return (
                                    <Box
                                        key={`${item?.id}_${fieldIndex}`}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: 1,
                                        }}
                                    >
                                        <BaseTextField
                                            autoComplete="off"
                                            fullWidth={false}
                                            name={`data.answers.${fieldIndex}.answer`}
                                            value={answerValue}
                                            size="small"
                                            placeholder="Nhập tùy chọn câu trả lời"
                                            sx={{
                                                ...styles.answer,
                                                display:
                                                    isCampaignPublicWithCode
                                                        ? 'none'
                                                        : 'block',
                                            }}
                                            multiline
                                            maxRows={10}
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 255,
                                                },
                                            }}
                                        />
                                        {/* <Box
                                            sx={{
                                                borderRight: `2px solid ${colors.main}`,
                                                height: '44px',
                                            }}
                                        ></Box> */}

                                        <BaseRating
                                            name={`data.answers.${fieldIndex}.score`}
                                            readOnly
                                            max={quantity}
                                            size="large"
                                            value={
                                                !starScoreFull
                                                    ? quantity - 0.5
                                                    : quantity
                                            }
                                            precision={!starScoreFull ? 0.5 : 1}
                                            icon={
                                                <StarIcon
                                                    sx={{ fontSize: '40px' }}
                                                />
                                            }
                                            emptyIcon={
                                                <StarIcon
                                                    sx={{ fontSize: '40px' }}
                                                />
                                            }
                                            sx={{
                                                '& .MuiRating-icon': {
                                                    fontSize: '40px',
                                                    margin: '0 4px',
                                                },
                                                '& .MuiRating-iconFilled': {
                                                    color: colors.main,
                                                },
                                                '& .MuiRating-iconHover': {
                                                    color: '#ff3d47',
                                                },
                                            }}
                                        />
                                        <Box
                                            display={'flex'}
                                            marginLeft={'auto'}
                                        >
                                            {answers.length > 1 && (
                                                <IconButton
                                                    onClick={() =>
                                                        removeAnswer(fieldIndex)
                                                    }
                                                >
                                                    <MinusIcon />
                                                </IconButton>
                                            )}
                                            <IconButton
                                                sx={{
                                                    display:
                                                        isCampaignPublicWithCode
                                                            ? 'none'
                                                            : 'inline-flex',
                                                }}
                                                onClick={() =>
                                                    insertAnswer(fieldIndex)
                                                }
                                            >
                                                <PlusIcon />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                );
                            }
                        )}
                    </Box>
                </Box>
            </Stack>
            <Stack
                flexDirection={'row'}
                flexWrap={'wrap'}
                gap={4}
                p={'35px'}
                sx={{
                    borderTop: `2px dashed var(--color-primary)`,
                }}
                display={'none'}
            >
                <Stack flexDirection={'column'} gap={'20px'}>
                    <RequiredLabel
                        label="Số hàng"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseNumberField
                        sx={styleInputNumber}
                        size="small"
                        name={`data.numberOfRows`}
                        min={1}
                        max={20}
                        InputProps={{
                            readOnly: true,
                        }}
                        forceDisableMinus={
                            !!question.answerFromOtherQuestionLogic?.id
                        }
                        forceDisablePlus={
                            !!question.answerFromOtherQuestionLogic?.id
                        }
                        disabled={!!question.answerFromOtherQuestionLogic?.id}
                        showMinus={false}
                        showPlus={false}
                    />
                </Stack>
                {/* <Stack flexDirection={'column'} gap={'20px'}>
                    <RequiredLabel
                        label="Số lượng"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseNumberField
                        sx={styleInputNumber}
                        size="small"
                        name={`data.quantity`}
                        min={1}
                        max={5}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                </Stack> */}
            </Stack>
        </Box>
    );
};

const styles = createStyleSheet({
    answer: {
        '& .MuiInputBase-root': {
            padding: '18px 18px',
            minWidth: '450px',
            minHeight: '44px',
            borderRadius: '50px',
            background: common.white,
        },
    },
});
export default QuestionScoreStar;
